// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"cc1cb237","658":"df766289","780":"3a84d446","787":"b94bfa30"}[chunkId] + ".chunk.js";
};